import styled from '@emotion/styled';
import { tokens, Loader } from '@hotjar/hotsauce';
import Trace from './assets/trace-line-testimonial.svg';
import TraceRound from './assets/trace-round-line-testimonial.svg';

export const Wrapper = styled.div<{ withTestimonials?: boolean }>`
  display: flex;
  flex-direction: column;
  min-height: 100vh;

  background-color: ${({ withTestimonials }) =>
    withTestimonials ? tokens.color.neutral_100 : 'transparent'};
  transition: background-color ease 0.25s;
`;

export const Content = styled.section`
  flex-grow: 1;
  display: flex;
`;

export const StyledLoader = styled(Loader)`
  margin: auto;
`;

export const TwoColumnLayout = styled(Content)`
  justify-content: center;
  align-items: center;
  gap: 10%;
  padding: 0 5%;
  max-width: 1400px;
  width: 100%;
  height: 100%;
  align-self: center;
`;

export const MainContent = styled.div`
  width: 50%;
  min-width: 400px;
  flex: 1 1 auto;

  @media ${tokens.breakpoint.minWidth.m} {
    form {
      max-width: 100%;
    }
  }
`;

export const AsideContent = styled.aside`
  display: none;
  align-items: flex-start;
  justify-content: center;
  gap: ${tokens.spacer.x4};
  padding: 0 70px;
  flex: 1 1 auto;

  @media ${tokens.breakpoint.minWidth.m} {
    display: flex;
    flex-direction: column;
  }
`;

export const AsideContentWithTrace = styled(AsideContent)<{ background?: 'round' | 'pointy' }>`
  max-width: 500px;
  align-self: stretch;

  &:before {
    content: '';
    width: 500px;
    height: 500px;
    position: fixed;
    bottom: 0;
    right: 0;

    @media (min-width: 1400px) and (min-height: 760px) {
      background: url('${({ background }) => (background === 'round' ? TraceRound : Trace)}') bottom
        right no-repeat;
      background-size: ${({ background }) => (background === 'round' ? '390px' : '500px')};
      background-position: 0 120%;
    }
  }
`;

export const Quote = styled.blockquote`
  ${tokens.text('header5')};
  position: relative;
  border: none;
  padding: 0;
  max-width: 315px;
  font-size: ${tokens.spacer.x2};
  font-style: italic;

  &:before,
  &:after {
    position: absolute;
    font-size: 96px;
    font-style: normal;
    color: ${tokens.color.text_disabled};
  }

  &:before {
    content: '“';
    top: 0px;
    left: -50px;
  }

  &:after {
    content: '”';
    right: -50px;
    bottom: -50px;
  }
`;

export const QuoteAuthor = styled.div`
  display: flex;
  gap: ${tokens.spacer.x2};
`;

export const AuthorAvatar = styled.img`
  width: 56px;
  height: 56px;
`;

export const AuthorInfo = styled.div`
  ${tokens.text('body2')};
  color: ${tokens.color.text_light};
  display: flex;
  flex-direction: column;
`;

export const AuthorName = styled.div`
  font-weight: 500;
`;

export const CompanySize = styled.div`
  margin-top: ${tokens.spacer.x0pt5};
  font-size: ${tokens.spacer.x1pt5};
`;

export const AuthorRole = styled.div``;
